import { isFlowerDessert } from '@merchant-backend/util'
import { isSiDaTeam } from '@util'
import React, { Component } from 'react'
import styles from './style.module.less'

/**
 * 营销中心介绍页底部购买 footer
 */
export default class extends Component {
  static defaultProps = {
    onClick: () => {},
    unit: '年'
  }

  render() {
    const {
      price,
      leftExtra,
      rightText,
      rightExtra,
      onClick,
      unit,
      render
    } = this.props
    const siDaTeam = isSiDaTeam()
    if (render) {
      return <div className={styles.footer}>{render}</div>
    }
    return (
      <div className={styles.footer}>
        {siDaTeam ? (
          <div className={styles.team_wrap}>
            <div className={styles.left}>
              服务优惠价
              <span>￥</span>
              <div className={styles['left-price']}>
                {price}
                <span>/{unit}</span>
              </div>
              {leftExtra}
            </div>
            <div className={styles.right}>
              <div className={styles['right-submit']} onClick={onClick}>
                {rightText}
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.normal_wrap}>
            <div className={styles.left}>
              {!isFlowerDessert() && (
                <>
                  服务优惠价：
                  <div className={styles['left-price']}>
                    <span>￥</span>
                    {price}
                  </div>
                  /{unit}
                </>
              )}
              {leftExtra}
            </div>

            <div className={styles.right}>
              {rightExtra}
              <div className={styles['right-submit']} onClick={onClick}>
                {rightText}
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}
